import { render, staticRenderFns } from "./bulkData.vue?vue&type=template&id=1a5be324&scoped=true&"
import script from "./bulkData.vue?vue&type=script&lang=js&"
export * from "./bulkData.vue?vue&type=script&lang=js&"
import style0 from "./bulkData.vue?vue&type=style&index=0&id=1a5be324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5be324",
  null
  
)

export default component.exports